/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { DropdownItemGroup } from '@atlaskit/dropdown-menu';
import LozengeActionItem from '../lozenge-action-item';
var dropdownItemGroupStyles = null;
var LozengeActionItemsGroup = function LozengeActionItemsGroup(_ref) {
  var items = _ref.items,
    testId = _ref.testId,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("span", {
    "data-testid": "".concat(testId, "-item-group"),
    className: ax(["_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29h1bda _wlxp1bda _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"]),
    style: {
      "--_1uho1ce": ix("inset 2px 0 0 ".concat("var(--ds-border-selected, #0C66E4)"))
    }
  }, /*#__PURE__*/React.createElement(DropdownItemGroup, null, items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(LozengeActionItem, _extends({}, item, {
      key: idx,
      onClick: onClick,
      testId: "".concat(testId, "-item-").concat(idx)
    }));
  })));
};
export default LozengeActionItemsGroup;